import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import PageSeo from '@/components/seo/PageSeo';

/**
 * Rota catch-all para URLs sem match (evita ecrã em branco).
 * Útil quando o utilizador abre um link novo antes do deploy do frontend.
 */
const NotFoundPublic = () => {
  return (
    <div className="min-h-[50vh] flex items-center justify-center py-12 px-4">
      <PageSeo title="Página não encontrada | Ufokko" path="/404" noindex />
      <Card className="w-full max-w-md border-0 bg-white/90 dark:bg-gray-800/90 shadow-xl">
        <CardHeader>
          <CardTitle className="text-xl text-gray-900 dark:text-gray-100">
            Página não encontrada
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p>
            Este endereço não existe nesta versão do site. Se veio de um e-mail de confirmação de
            conta, atualize a página ou tente de novo após alguns minutos — o site pode estar a ser
            atualizado.
          </p>
          <Button asChild className="w-full">
            <Link to="/">Ir ao início</Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">Login</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFoundPublic;
